import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { SubjectEntity } from '../subject.entity';

export const STATE_NAME = 'subjectEntity';

export const SubjectEntityState: GenericEntityStateClass<SubjectEntity> =
  createEntityState<SubjectEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class SubjectEntityService extends EntityService<SubjectEntity> {
  constructor() {
    super();
    this.resourceType = 'subjects';
    this.stateClass = SubjectEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): SubjectEntity[] => {
      const slice = storeState[sliceName];
      const result = stateClass.allByQuery(slice, { query });
      return [...result].sort((a, b) => a.name.localeCompare(b.name, 'de', { sensitivity: 'base', numeric: true }));
    };
  }
}
